import * as angular from "angular";

angular
  .module('bringoz.admin.tasks')
  .constant('Tasks_PN', {
    database: 'tasks',
    isBranchEntity: true
  });
